import React, { Component } from 'react';
import '../assets/custom.css';
import '../assets/teachers.css';
import { withRouter } from 'react-router-dom';
import HeaderComponent from '../Shared/Header';
import REST from '../Shared/REST';
import ico_plus_green from '../assets/images/ico_plus_green.png';
import ico_view from '../assets/images/ico_view.png';
import FooterComponent from "../Shared/Footer";
import DialogBox from "../Shared/DialogBox";
import DeleteDialogBox from "../Shared/DeleteDialogBox";
import {Nav, NavItem, OverlayTrigger, Popover, Tooltip} from 'react-bootstrap';
import Select from 'react-select';

const tooltipSchools = (
    <Tooltip id="tooltipSchools">
        Multiple Select Option
    </Tooltip>
);
const getValue = (opts, val) => opts.find(o => o.value == val);

let addClassInstruction = null;
let addStudentInstruction = null;
let schoolOptions = [];
let samplingStrategyOptions = [];


class SchoolManagementComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            schools: [],
            samplingStrategies: [],
            schoolToEdit: {},
            addSchool: false,
            editSchool: false,
            listTeachers: false,
            editTeacher: false,
            teacherToEdit: {},
            schoolOptions:[],
            samplingStrategyOptions:[]
        };
    }

    async componentDidMount() {
        let schools = [];
        await REST.listSchools().then(async(response) => {
            if (response.success) {
                schools = response.body;
                schoolOptions = [];
                for (let school of schools) {
                    schoolOptions.push({value: school.id, label: school.name});
                }
                await REST.listSamplingStrategies().then(async(results) => {
                    if (results.success) {
                        samplingStrategyOptions = [];
                        let samplingStrategies = results.body;
                        for (let samplingStrategy of samplingStrategies) {
                            samplingStrategyOptions.push({value: samplingStrategy.id, label: samplingStrategy.name});
                        }
                        await this.setState({
                            schools: schools,
                            schoolOptions: schoolOptions,
                            samplingStrategyOptions: samplingStrategyOptions
                        });
                    } else {
                        console.log('Error', response.msg);
                    }
                }, (error) => {
                    console.log('Error', error.msg);
                });
            } else {
                console.log('Error', response.msg);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });

    }

    /*handleShowSchool(event) {
        this.setState({ addSchool: !this.state.addSchool, editSchool: false, listTeachers: false });
    }*/

    handleCancel = () => {
        this.setState({ addSchool: false, editSchool: false });
    }

    handleAddSchool= (object) => {
        this.setState({
            addSchool: true,
            editSchool: false,
            listTeachers: false,
            editTeacher: false });
    }

    handleShowSchool= (object) => {
        this.setState({
            addSchool: false,
            editSchool: true,
            listTeachers: false,
            editTeacher: false,
            schoolToEdit: object });
        console.log(object);
    }

    handleSchoolItemClick = (object) => {
        REST.listTeachersInSchool(object.id).then(async (response) => {
            if (response.success) {
                await this.setState({
                    addSchool: false,
                    editSchool: false,
                    listTeachers: true,
                    editTeacher: false,
                    teachers: response.body
                });
            }
            else {
                console.log('Error', response.msg);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });
    }

    handleTeacherItemClick = (object) => {
        this.setState({
            addSchool: false,
            editSchool: false,
            listTeachers: false,
            editTeacher: true,
            teacherToEdit: object
        });
    }

    teacherAdded = (object) => {
        this.setState({
            addSchool: false,
            editSchool: false,
            listTeachers: false,
            editTeacher: false
        });
    }

    teacherUpdated = async (object) => {
        await this.setState({
            addSchool: false,
            editSchool: false,
            listTeachers: false,
            editTeacher: false
        });
        setTimeout(async()=>{
            await this.setState({
                listTeachers: true
            });
        },500);
    }

    teacherDeleted = (object) => {
        this.setState({
            addSchool: false,
            editSchool: false,
            listTeachers: false,
            editTeacher: false
        });
    }

    handleUpdateTeacherCancel = (object) => {
        this.setState({
            addSchool: false,
            editSchool: false,
            listTeachers: true,
            editTeacher: false
        });
    }

    handleLogout = () => {
        REST.logout().then((response) => {
            if(localStorage.getItem('addClass') === 'hide'){
                addClassInstruction = localStorage.getItem('addClass');
            }
            if(localStorage.getItem('addStudent') === 'hide'){
                addStudentInstruction = localStorage.getItem('addStudent');
            }
            localStorage.removeItem('token');
            if(addClassInstruction !== null){
                localStorage.setItem('addClass',addClassInstruction);
            }
            if(addStudentInstruction !== null){
                localStorage.setItem('addStudent',addStudentInstruction);
            }
            this.props.history.push("/login");
        }, (error) => {
            localStorage.removeItem('token');
            localStorage.clear();
            this.props.history.push("/login");
        });
    }

    schoolAdminAdded = async () => {
        this.listSchoolAdmins();
    }

    schoolAdded = async () => {
        let schools = [];
        await REST.listSchools().then(async(response) => {
            if (response.success) {
                schools = response.body;
                schoolOptions = [];
                for (let school of schools) {
                    schoolOptions.push({value: school.id, label: school.name});
                }
                await this.setState({
                    schools: schools,
                    schoolOptions: schoolOptions,
                });
            } else {
                console.log('Error', response.msg);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });
    }

    render() {
        return (
            <div>
                <HeaderComponent schoolManagement={true}  logout={this.handleLogout} />
                <div className="section bgGrey">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <div className={"row"}>
                                    <div className={"col-md-10"}>
                                        <h1 className="fl">Schools</h1>
                                    </div>
                                    <div className={"col-md-2"}>
                                        <a className="fr">
                                            <img src={ico_plus_green} onClick={this.handleAddSchool} alt="Plus Icon" border="0" className="ico-xs ico-add" />
                                        </a>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 solidBorder noPadding scrollable">
                                    <SchoolListComponent schools={this.state.schools} handleItemClick={this.handleSchoolItemClick} handleShowSchool={this.handleShowSchool}/>
                                </div>
                            </div>
                            {this.state.listTeachers ?
                                <div className="col-md-9 container navbar-container">
                                    <h1 className="fl">Teachers</h1>
                                    <TeacherListComponent
                                        schoolId={this.state.schoolId}
                                        handleAddTeacher={this.handleAddTeacher}
                                        teachers={this.state.teachers}
                                        handleItemClick={this.handleTeacherItemClick}
                                        deleteTeacher={this.props.deleteTeacher}
                                    />
                                </div>
                                :null
                            }
                            {this.state.editTeacher ?
                                <div className="col-md-9 container navbar-container">
                                    <UpdateTeacherComponent handleTeacherUpdated={this.teacherUpdated} handleTeacherDeleted={this.teacherDeleted} teacher={this.state.teacherToEdit} schoolOptions = {this.state.schoolOptions} samplingStrategyOptions = {this.state.samplingStrategyOptions} handleCancel={this.handleUpdateTeacherCancel} />
                                </div> : null}
                            {this.state.addSchool ?
                                <div className="col-md-9 container navbar-container">
                                    <AddSchoolComponent samplingStrategyOptions={this.state.samplingStrategyOptions} handleSchoolAdded={this.schoolAdded} handleCancel={this.handleCancel} />
                                </div> : null}
                            {this.state.editSchool ?
                                <div className="col-md-9 container navbar-container">
                                    <UpdateSchoolComponent samplingStrategyOptions={this.state.samplingStrategyOptions} handleSchoolUpdated={this.schoolAdded} school={this.state.schoolToEdit} handleCancel={this.handleCancel} />
                                </div> : null}
                        </div>
                    </div>
                </div>
                <FooterComponent/>
            </div>
        );
    }
}

class TeacherListComponent extends Component {
    handleItemClick = (object) => {
        this.props.handleItemClick(object);
    }

    render() {
        let items = this.props.teachers;
        const teachers = items.map((item) => {
            return <TeacherListItemComponent key={item.id} item={item} handleClick={this.handleItemClick} />
        });
        return (
            <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                <thead>
                <tr className="clickable-row">
                    <th className="fitWidth">Username</th>
                    <th>Sampling Strategy</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {teachers}
                </tbody>
            </table>
        );
    }
}

class TeacherListItemComponent extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        this.props.handleClick(this.props.item);
        event.preventDefault();
    }

    render() {
        return (
            <tr onClick={this.handleClick} className="clickable-row">
                <td >{this.props.item.user.username}</td>
                <td >{this.props.item.sampling_strategy.name}</td>
                <td className="fitWidth">
                    <a>
                        <img src={ico_view} alt="View Icon" border="0" className="ico-xs" />
                    </a>
                </td>
            </tr>
        );
    }
}

class UpdateTeacherComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstname: this.props.teacher.user.firstname,
            lastname: this.props.teacher.user.lastname,
            email: this.props.teacher.user.email,
            inProject: true,
            userId: this.props.teacher.userId,
            username: this.props.teacher.user.username,
            researcher: this.props.teacher.researcher,
            schoolId: this.props.teacher.schoolId,
            samplingStrategyId: this.props.teacher.samplingStrategyId,
            modalDialog:false,
            modalDialogDelete:false
        };
        this.handleName = this.handleName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleUserName = this.handleUserName.bind(this);
        this.handleReseacher = this.handleReseacher.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.deleteTeacher = this.deleteTeacher.bind(this);
    }

    componentDidUpdate(oldProps){
        const newProps = this.props;
        if(oldProps.teacher.userId !== newProps.teacher.userId){
            this.setState({
                firstname: this.props.teacher.user.firstname,
                lastname: this.props.teacher.user.lastname,
                email: this.props.teacher.user.email,
                schoolId: this.props.teacher.schoolId,
                samplingStrategyId: this.props.teacher.samplingStrategyId,
                username: this.props.teacher.user.username,
                researcher: this.props.teacher.researcher,
                modalDialog:false,
                modalDialogDelete:false });
        }
    }

    deleteTeacher = (confirm) =>{
        if(confirm) {
            this.handleDelete();
        }
        this.setState({
            modalDialogDelete:false,
        });
    }

    handleName(event) {
        this.setState({ firstname: event.target.value.replace(/\s+/g, '') });
        event.preventDefault();
    }

    handleLastName(event) {
        this.setState({ lastname: event.target.value.replace(/\s+/g, '') });
        event.preventDefault();
    }

    handleEmail(event) {
        this.setState({ email: event.target.value });
        event.preventDefault();
    }

    handleUserName(event) {
        this.setState({ username: event.target.value });
        event.preventDefault();
    }

    handleReseacher(event) {
        this.setState({ researcher: !this.state.researcher });
        // event.preventDefault();
    }

    handleCancel(event) {
        this.props.handleCancel();
        event.preventDefault();
    }

    handleSave(event) {
        REST.updateTeacher(this.state).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent:'Teacher Data Successfully Updated!'
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
                this.props.handleTeacherUpdated();
            }
            else {
                alert(response.msg);
            }
        }, (error) => {
            alert(error.msg);
        });
        event.preventDefault();
    }

    handleDelete(event) {
        REST.deleteTeacher(this.state.userId).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent:'Teacher Successfully Deleted!'
                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.props.handleCancel();this.props.handleTeacherDeleted();},3500);
            }
            else {
                alert(response.msg);
            }
        }, (error) => {
            alert(error.msg);
        });
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder hasfitWidth" style={{height:600}}>
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <DeleteDialogBox
                    confirmDelete={this.deleteTeacher}
                    modalOpen={this.state.modalDialogDelete}
                    sectionContent={this.state.responseContent}
                    closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <form>
                    <label htmlFor="inputTeacherName">First Name</label>
                    <input type="text" value={this.state.firstname} onChange={this.handleName} id="inputTeacherName" className="form-control" placeholder="First Name" required autoFocus />
                    <label htmlFor="inputTeacherLastName">Last Name</label>
                    <input type="text" value={this.state.lastname} onChange={this.handleLastName} id="inputTeacherLastName" className="form-control" placeholder="Last Name" required />
                    <label htmlFor="inputTeacherUserName">User Name</label>
                    <input type="text" value={this.state.username} onChange={this.handleUserName} id="inputTeacherUserName" className="form-control" placeholder="User Name" required />
                    <label htmlFor="inputTeacherEmail">School</label>
                    <div style={{width:'68%'}}>
                        <Select
                            id={"updateTeacherSchool"}
                            onChange={(newValue)=>{this.setState({ schoolId: newValue.value})}}
                            options={this.props.schoolOptions}
                            placeholder = {"Select a school..."}
                            value={getValue(this.props.schoolOptions, this.state.schoolId)}
                        />
                    </div><br/>
                    <label htmlFor="inputTeacherSamplingStrategy">Sampling Strategy</label>
                    <div style={{width:'68%'}}>
                        <Select
                            id={"updateTeacherSamplingStrategy"}
                            onChange={(newValue)=>{this.setState({ samplingStrategyId: newValue.value})}}
                            options={this.props.samplingStrategyOptions}
                            placeholder = {"Select a sampling strategy..."}
                            value={getValue(this.props.samplingStrategyOptions, this.state.samplingStrategyId)}
                        />
                    </div>
                    <label style={{width:'30%'}}> </label>
                    <div style={{display:'inline-block', position:'relative', width:'70%'}}>
                        <label htmlFor="cbResearcher" className="cb "><input type="checkbox" onChange={this.handleReseacher} name="researcher" checked={this.state.researcher} id="cbResearcher" /><span className="checkmark"></span> Researcher</label>
                    </div><br/>
                </form>
                <div className="nav navbar fl">
                    <a onClick={(event)=>{this.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS TEACHER?'});   event.stopPropagation();}} className="handBtn">
                        <span>Delete Teacher</span>
                    </a>
                </div>
                <div className="nav navbar fr">
                    <a onClick={this.handleCancel} className="handBtn">
                        <span>Cancel</span>
                    </a>
                    <a onClick={this.handleSave} className="handBtn">
                        <span>Save Changes</span>
                    </a>
                </div>
            </div>
        );
    }
}


class AddSchoolComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            modalDialog:false,
            responseContent:'',
            samplingStrategyId: 1,
            samplingStrategyOptions: this.props.samplingStrategyOptions
        };
        this.handleName = this.handleName.bind(this);
        this.handleSamplingStrategyChange = this.handleSamplingStrategyChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleName(event) {
        this.setState({ name: event.target.value });
        event.preventDefault();
    }

    async handleSamplingStrategyChange(value) {
        await this.setState({ samplingStrategyId: value.value});

    }

    handleCancel(event) {
        this.props.handleCancel();
    }

    handleSave(event) {
        REST.createSchool(this.state).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent: 'School Admin Successfully Added!'
                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.props.handleCancel();},2500);
                this.props.handleSchoolAdded();
                this.myFormRef.reset();
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg
                });
                setTimeout(()=>{this.setState({modalDialog:false})},2500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:'The school is already in the list.'
            });
            setTimeout(()=>{this.setState({modalDialog:false})},2500);
        });
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder hasfitWidth">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <form id="formAddSchoolAdmin" ref={(el) => this.myFormRef = el}>
                    <label htmlFor="inputSchoolName">School Name</label>
                    <input type="text" onChange={this.handleName} id="inputSchoolAdminName" className="form-control" placeholder="First Name" required autoFocus />
                    <label htmlFor="inputSchoolSamplingStrategy">Sampling Strategy</label>
                    <Select  onChange={this.handleSamplingStrategyChange} id="inputSamplingStrategy" className="basic-multi-select" options={this.state.samplingStrategyOptions} className={this.state.samplingStrategyError} isMulti={false} isSearchable={false} />
                    <br/>
                </form>
                <div className="nav navbar fr">
                    <a onClick={this.handleCancel} className="handBtn">
                        <span>Cancel</span>
                    </a>
                    <a onClick={this.handleSave} className="handBtn">
                        <span>Save Changes</span>
                    </a>
                </div>
            </div>
        );
    }
}

class UpdateSchoolComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.school.id,
            name: this.props.school.name,
            samplingStrategyId: this.props.school.sampling_strategy.id,
            samplingStrategy: this.props.school.sampling_strategy.name,
            samplingStrategyDescription: this.props.school.sampling_strategy.description,
            samplingStrategyOptions: this.props.samplingStrategyOptions,
            modalDialog:false,
            modalDialogDelete:false
        };
        this.handleName = this.handleName.bind(this);
        this.handleSamplingStrategyChange = this.handleSamplingStrategyChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        this.setState({
            id: this.props.school.id,
            name: this.props.school.name,
            samplingStrategyId: this.props.school.sampling_strategy.id,
            samplingStrategy: this.props.school.sampling_strategy.name,
            samplingStrategyDescription: this.props.school.sampling_strategy.description,
            samplingStrategyOptions: this.props.samplingStrategyOptions,
            modalDialog:false,
            modalDialogDelete:false });
    }

    componentDidUpdate(oldProps){
        const newProps = this.props;
        if(oldProps.school.id !== newProps.school.id){
            this.setState({
                id: this.props.school.id,
                name: this.props.school.name,
                samplingStrategyId: this.props.school.sampling_strategy.id,
                samplingStrategy: this.props.school.sampling_strategy.name,
                samplingStrategyDescription: this.props.school.sampling_strategy.description,
                samplingStrategyOptions: this.props.samplingStrategyOptions,
                modalDialog:false,
                modalDialogDelete:false });
        }
    }

    handleName(event) {
        this.setState({ name: event.target.value });
        event.preventDefault();
    }

    async handleSamplingStrategyChange(value) {
        await this.setState({ samplingStrategyId: value.value});

    }

    handleCancel(event) {
        this.props.handleCancel();
    }

    handleSave(event) {
        REST.updateSchool(this.state).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent: 'School Admin Successfully Added!'
                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.props.handleCancel();},2500);
                this.props.handleSchoolUpdated();
                this.myFormRef.reset();
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg
                });
                setTimeout(()=>{this.setState({modalDialog:false})},2500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg
            });
            setTimeout(()=>{this.setState({modalDialog:false})},2500);
        });
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder hasfitWidth">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <form id="formAddSchoolAdmin" ref={(el) => this.myFormRef = el}>
                    <label htmlFor="inputSchoolName">School Name</label>
                    <input type="text" value={this.state.name} onChange={this.handleName} id="inputSchoolAdminName" className="form-control" placeholder="First Name" required autoFocus />
                    <label htmlFor="inputSchoolSamplingStrategy">Sampling Strategy</label>
                    <Select  defaultValue={getValue(this.state.samplingStrategyOptions, this.state.samplingStrategyId)} onChange={this.handleSamplingStrategyChange} id="inputSamplingStrategy" className="basic-multi-select" options={this.state.samplingStrategyOptions} className={this.state.samplingStrategyError} isMulti={false} isSearchable={false} />
                    <br/>
                </form>
                <div className="nav navbar fr">
                    <a onClick={this.handleCancel} className="handBtn">
                        <span>Cancel</span>
                    </a>
                    <a onClick={this.handleSave} className="handBtn">
                        <span>Save Changes</span>
                    </a>
                </div>
            </div>
        );
    }
}

class SchoolListComponent extends Component {
    handleItemClick = (object) => {
        this.props.handleItemClick(object);
    }

    handleShowLCSchool = (object) => {
        this.props.handleShowSchool(object);
    }

    render() {
        let items = this.props.schools;
        const schools = items.map((item) => {
            return <SchoolListItemComponent key={item.id} item={item} handleShowLCSchool={this.handleShowLCSchool} handleClick={this.handleItemClick} />
        });
        return (
            <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                <tbody>
                {schools}
                </tbody>
            </table>
        );
    }
}

class SchoolListItemComponent extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        this.props.handleClick(this.props.item);
        event.preventDefault();
    }

    handleShowSchool= () => {
        this.props.handleShowLCSchool(this.props.item);
        //event.preventDefault();
    }

    render() {
        return (
            <tr className="clickable-row">
                <td onClick={this.handleClick}>{this.props.item.name}</td>
                <td onClick={this.handleShowSchool} className="fitWidth">
                    <a>
                        <img src={ico_view} alt="View Icon" border="0" className="ico-xs" />
                    </a>
                </td>
            </tr>
        );
    }
}

export default withRouter(SchoolManagementComponent);